module.exports = new __parcel__URL__("ride_10.c4914e82.mp3").toString();